import React from "react";
import { Phone, Mail } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

const LOGO_URL = "/elysian-logo.png";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-[#0B0B0B] border-t border-white/5 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 md:gap-12">
          <div>
            <img
              src={LOGO_URL}
              alt="Elysian Cars"
              className="h-[72px] md:h-[92px] w-auto object-contain drop-shadow-[0_2px_14px_rgba(198,161,91,0.22)]"
            />
            <p className="mt-6 text-[11px] tracking-[0.32em] uppercase text-zinc-500">
              {t("footer.company")}
            </p>
          </div>

          <ul className="flex flex-col gap-3 text-sm text-zinc-300 md:text-right">
            <li className="flex items-center gap-3 md:justify-end">
              <Phone size={14} className="text-[#C6A15B]" />
              <a
                href="tel:+306948559619"
                className="hover:text-[#C6A15B] transition-colors"
                data-testid="footer-phone"
              >
                +30 694 855 9619
              </a>
            </li>
            <li className="flex items-center gap-3 md:justify-end">
              <Mail size={14} className="text-[#C6A15B]" />
              <a
                href="mailto:info@elysiancars.com"
                className="hover:text-[#C6A15B] transition-colors"
                data-testid="footer-email"
              >
                info@elysiancars.com
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-12 md:mt-16 pt-6 md:pt-7 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-[10px] text-zinc-500 tracking-[0.26em] uppercase">
            © {new Date().getFullYear()} Elysian Cars {t("footer.rights")}
          </p>
          <p className="text-[10px] text-zinc-600 tracking-[0.32em] uppercase">
            {t("footer.signature")}
          </p>
        </div>
      </div>
    </footer>
  );
}
